import * as React from 'react';
export var LinkCard = function (_a) {
    var icon = _a.icon, title = _a.title, description = _a.description, children = _a.children;
    return (React.createElement("div", { className: "card link-card text-center" },
        React.createElement("i", { className: icon }),
        React.createElement("h5", null, title),
        React.createElement("div", null,
            React.createElement("small", null, description)),
        children));
};
//# sourceMappingURL=index.js.map